<template>
  <SubSidebarLayout :menu-categories="menuCategories">
    <template v-slot:heading>
      <a
        :href="adminRootPath(currentSite)" target="_blank"
        v-if="currentSite"
        class="d-flex justify-start mt-3"
        style="width: 150px;color:black"
      >
        <v-img
          v-if="currentSite.favicon.url != null"
          :src="siteFaviconSrc"
          class="mr-5"
          style="
            width: 100%;
            max-width: 40px;
            height: 40px;
            border: 1px solid #eee;
            border-radius: 8px;
          "
        />
        <v-img
          v-else
          :src="require('@/assets/small_thumb_no_image.jpg')"
          class="mr-5"
          style="
            width: 100%;
            max-width: 40px;
            height: 40px;
            border: 1px solid #eee;
            border-radius: 8px;
          "
        />
        <span
          class="body-1 font-weight-bold align-self-center"
          style="min-width: 120px"
          >{{ currentSite.name }}</span
        >
      </a>
    </template>
  </SubSidebarLayout>
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'
import { mapState } from 'vuex'
import urlUtils from '@/mixins/url_utils'

export default {
  components: {
    SubSidebarLayout
  },
  mixins: [urlUtils],
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth

    }),
    currentSite () {
      if (!this.$route.params.siteKey) return

      return this.currentUserAuth.sites.find(
        (site) => site.siteKey === this.$route.params.siteKey
      )
    },
    siteFaviconSrc () {
      if (this.currentSite.favicon.url.indexOf('http') === 0) {
        return this.currentSite.favicon.url
      }

      return (
        this.currentSite.originalDomainWithProtocol +
        this.currentSite.favicon.url
      )
    }
  },
  data: () => ({
    menuCategories: [
      {
        name: '記事',
        items: [
          {
            text: '記事一覧',
            router: { name: 'masterAdminPosts' }
          },
          {
            text: 'コピーチェック一覧',
            router: { name: 'masterAdminCopyChecks' }
          }
        ]
      },
      {
        name: '発注管理',
        items: [
          {
            text: '発注一覧',
            router: { name: 'masterAdminOrders' }
          },
          {
            text: '一括発注',
            router: { name: 'masterAdminBulkRegistration' }
          },
          {
            text: '検収管理',
            router: { name: 'masterAdminClientInspectionManagement' }
          }
        ]
      }
    ]
  })
}
</script>
